import styled from 'styled-components';

export const Button = styled.button`
	&:focus {
		outline: 0 !important;
		box-shadow: none !important;
	}
`;

export const ContainerAnnotation = styled.section`
	.title {
		color: #707070;
		font-family: Poppins-Medium, Heltica, Arial, sans-serif;
		font-size: 15px;
		margin-bottom: 0;
	}

	textarea {
		font-family: Poppins, Heltica, Arial, sans-serif;
		font-size: 16px;
		color: #333333;
		width: 100%;
		height: 150px;
		resize: none;
		padding: 15px;
		border-radius: 5px;
		outline: 0;
	}

	.btn {
		font-family: Poppins, Heltica, Arial, sans-serif;
		font-size: 15px;
		text-transform: uppercase;
		padding: 10px 30px;
	}
`;

export const ContainerInteractions = styled.div`
	position: relative;
	
	.file-drag-drop {
		font-family: Poppins,Heltica,Arial,sans-serif;
    	color: #707070;
    	.btn{
    			font-size: large;
    		}
	}

	.fade-panel.show {
		border-radius: 0 0 8px 8px;
		background: linear-gradient(to bottom, rgba(10, 10, 10, 0) 0%, rgba(20, 20, 20, .4) 85%);
		height: 75px;
		margin-top: -110px;
		position: absolute;
		width: 100%;
		left: 0;
		bottom: 0;
	}

	.controller-fade-panel {
		display: none;
		position: absolute;
    left: 0;
    bottom: 10px;
    margin: auto;
    text-align: center;
    width: 100%;
    z-index: 1;

		button {
			background-color: transparent;
			padding: 3px 15px;
			background-color: #EEEEEE;
			border: 1px solid #DDDDDD;
			color: #707070;
    	font-size: 14px;
			transition: all .3s ease-in-out;

			&:hover {
				opacity: .8;
			}
		}

		&.show {
			display: block;
		}
	}
`;

export const Box = styled.div`
	box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
	margin-top: ${props => props.marginTop || null};
	border-radius: ${props => props.borderRadius || null};
	padding: ${props => props.padding || null};
`;
